import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Command"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 9.75C19.6569 9.75 21 8.40685 21 6.75V6C21 4.34315 19.6569 3 18 3H17.25C15.5931 3 14.25 4.34315 14.25 6V8.25H9.75V6C9.75 4.34315 8.40685 3 6.75 3H6C4.34315 3 3 4.34315 3 6V6.75C3 8.40685 4.34315 9.75 6 9.75H8.25V14.25H6C4.34315 14.25 3 15.5931 3 17.25V18C3 19.6569 4.34315 21 6 21H6.75C8.40685 21 9.75 19.6569 9.75 18V15.75H14.25V18C14.25 19.6569 15.5931 21 17.25 21H18C19.6569 21 21 19.6569 21 18V17.25C21 15.5931 19.6569 14.25 18 14.25H15.75V9.75H18ZM15.75 6C15.75 5.17157 16.4216 4.5 17.25 4.5H18C18.8284 4.5 19.5 5.17157 19.5 6V6.75C19.5 7.57843 18.8284 8.25 18 8.25H15.75V6ZM6 8.25C5.17157 8.25 4.5 7.57843 4.5 6.75V6C4.5 5.17157 5.17157 4.5 6 4.5H6.75C7.57843 4.5 8.25 5.17157 8.25 6V8.25H6ZM8.25 18C8.25 18.8284 7.57843 19.5 6.75 19.5H6C5.17157 19.5 4.5 18.8284 4.5 18V17.25C4.5 16.4216 5.17157 15.75 6 15.75H8.25V18ZM14.25 14.25H9.75V9.75H14.25V14.25ZM15.75 15.75H18C18.8284 15.75 19.5 16.4216 19.5 17.25V18C19.5 18.8284 18.8284 19.5 18 19.5H17.25C16.4216 19.5 15.75 18.8284 15.75 18V15.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Command.vue"]]);
